import { render, staticRenderFns } from "./CompSalesCard.vue?vue&type=template&id=b3d97f70&scoped=true"
import script from "./CompSalesCard.vue?vue&type=script&lang=js"
export * from "./CompSalesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d97f70",
  null
  
)

export default component.exports